const common = require("lib/labels/_common");

// Home.steps

module.exports = {
  back: {
    en: "Back",
    fr: "Retour"
  },
  cancel: common.cancel,
  submit: {
    en: "Submit",
    fr: "Confirmer"
  },
  next: {
    en: "Next",
    fr: "Suivant"
  }
};
